import React, { useState, useEffect } from 'react'
import { Toast, ToastBody, ToastHeader } from 'reactstrap'
import { motion } from 'framer-motion'

const ToastItem = (props) => {
  const [show, setShow] = useState(true)
  const toggle = () => setShow(!show)

  useEffect(() => {
    let hideTimer = setTimeout(() => setShow(false), 8000)
    return () => {
      clearTimeout(hideTimer)
    }
  }, [])

  if (props.toast.type === 'save') {
    return (
      <motion.li
        key={props.key}
        positionTransition
        initial={{ opacity: 0, y: 50, scale: 0.3 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      >
        <Toast isOpen={show}>
          <ToastHeader icon="success" toggle={toggle}>
            Success
          </ToastHeader>
          {props.toast.payload === 'user' && <ToastBody>Saved user successfully.</ToastBody>}
          {props.toast.payload === 'sync' && <ToastBody>Company sync successful.</ToastBody>}
          {props.toast.payload === 'report' && <ToastBody>Report saved successfully</ToastBody>}
          {props.toast.payload === 'settings' && <ToastBody>Settings saved successfully.</ToastBody>}
          {!['user', 'sync', 'report', 'settings'].includes(props.toast.payload) && (
            <ToastBody>{props.toast.payload}</ToastBody>
          )}
        </Toast>
      </motion.li>
    )
  } else if (props.toast.type === 'delete') {
    return (
      <motion.li
        key={props.key}
        positionTransition
        initial={{ opacity: 0, y: 50, scale: 0.3 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      >
        <Toast isOpen={show}>
          <ToastHeader icon="primary" toggle={toggle}>
            Deleted
          </ToastHeader>
          {props.toast.payload === 'company' && <ToastBody>Company Deleted.</ToastBody>}
          {props.toast.payload === 'report' && <ToastBody>Report Deleted</ToastBody>}
        </Toast>
      </motion.li>
    )
  } else if (props.toast.type === 'warning') {
    return (
      <motion.li
        key={props.key}
        positionTransition
        initial={{ opacity: 0, y: 50, scale: 0.3 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      >
        <Toast isOpen={show}>
          <ToastHeader icon="warning" toggle={toggle}>
            Warning
          </ToastHeader>
          <ToastBody>{props.toast.payload}</ToastBody>
        </Toast>
      </motion.li>
    )
  } else if (props.toast.type === 'error') {
    return (
      <motion.li
        positionTransition
        initial={{ opacity: 0, y: 50, scale: 0.3 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      >
        <Toast isOpen={show}>
          <ToastHeader icon="danger" toggle={toggle}>
            Error
          </ToastHeader>

          <ToastBody>{props.toast.payload || 'Sorry, something went wrong. Please try again later.'}</ToastBody>
        </Toast>
      </motion.li>
    )
  } else {
    return <div></div>
  }
}

export default ToastItem
